import React from 'react';

/**
 * Proposed glyph for the certificate check — a stamped seal with a lit
 * beacon at its centre, built from the brand mark's beacon + arc.
 */
export function CertSeal({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" focusable="false" data-id="element-184" data-mp="3a8x0i97wb2gc">
      <circle cx="12" cy="12" r="9.1" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2.3 2.3" strokeLinecap="round" data-id="element-185" data-mp="3f545nzsgw9x8" />
      <circle cx="12" cy="12" r="6.3" stroke="currentColor" strokeWidth="1.4" data-id="element-186" data-mp="2mgq63flqd5jk" />
      <path d="M9.1 11.5a4.1 4.1 0 0 1 5.8 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" opacity="0.6" data-id="element-187" data-mp="2w8cj9hhmpeoy" />
      <circle cx="12" cy="13.4" r="1.7" fill="currentColor" data-id="element-188" data-mp="1yr4b74ce5chd" />
    </svg>;
}